import { SpinnerGap, DownloadSimple } from "@phosphor-icons/react";

// Rendered on top of all 3 video sources (YouTube/uploaded/Bunny) — kept as
// one shared component instead of triplicated JSX so the highlight box and
// highlights banner can never drift between the 3 near-identical blocks in
// GameDetail.jsx.
export function VideoOverlays({
  highlight, analysis, highlightsActive, clip, clipIndexDisplay, clipsCount,
  eventLabel, isViewer, downloadingClipId, clipDownloadStage, onDownloadClip, onStopHighlights,
}) {
  return (
    <>
      {highlight && analysis?.frame_width && analysis?.frame_height && (
        <div
          data-testid="player-highlight-box"
          className="absolute border-2 border-[#CCFF00] rounded-sm shadow-[0_0_14px_rgba(204,255,0,0.65)] pointer-events-none transition-all duration-150"
          style={{
            left: `${(highlight.box[0] / analysis.frame_width) * 100}%`,
            top: `${(highlight.box[1] / analysis.frame_height) * 100}%`,
            width: `${Math.max(0, ((highlight.box[2] - highlight.box[0]) / analysis.frame_width) * 100)}%`,
            height: `${Math.max(0, ((highlight.box[3] - highlight.box[1]) / analysis.frame_height) * 100)}%`,
          }}
        >
          <span data-testid="player-highlight-label" className="absolute top-full left-0 mt-1 bg-[#CCFF00] text-black text-[9px] font-label px-1 py-0.5 rounded-sm whitespace-nowrap">{highlight.label}</span>
        </div>
      )}
      {highlightsActive && clip && (
        <div data-testid="highlights-banner" className="absolute top-2 left-2 right-2 flex items-center justify-between gap-2 bg-black/70 backdrop-blur-sm rounded-sm px-3 py-2">
          <span className="font-label text-xs text-white">
            Clip {clipIndexDisplay + 1} of {clipsCount} — {eventLabel(clip)}
          </span>
          <div className="flex items-center gap-2 shrink-0">
            {!isViewer && (
              <button type="button" onClick={() => onDownloadClip(clip)} disabled={downloadingClipId === clip.id} data-testid="highlights-banner-download-btn" className="flex items-center gap-1 font-label uppercase text-[10px] text-white px-2 py-1 rounded-sm bg-white/10 hover:bg-white/20 transition-colors duration-150 disabled:opacity-50">
                {downloadingClipId === clip.id ? <SpinnerGap size={11} className="animate-spin" /> : <DownloadSimple size={11} weight="bold" />} {downloadingClipId === clip.id ? clipDownloadStage : "Download"}
              </button>
            )}
            <button type="button" onClick={onStopHighlights} data-testid="highlights-banner-stop-btn" className="font-label uppercase text-[10px] text-white px-2 py-1 rounded-sm bg-white/10 hover:bg-white/20 transition-colors duration-150">Stop</button>
          </div>
        </div>
      )}
    </>
  );
}
